export default {
    // SERVER: 'https://test.dtc121.ro/api/consumer-app',
    // SERVER: 'http://dev2022a.dtc121.ro/api/consumer-app',
    SERVER: 'https://live.dtc121.ro/api/consumer-app',
    GET_CONSUMER_DATA: '/get-interaction-data',
    SET_CONSUMER_DATA: '/set-consumer-app-data'        
};